import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { debounce, debounceTime } from 'rxjs/operators';
import { ICustomer } from '../../interfaces/customer';
import { ICustomerFilter } from '../../interfaces/customer-filter';
import { IPageResult } from '../../interfaces/page-result';
import { CustomerService } from '../../services';
import { flatten } from '../../utils/flatten';
import { Table } from 'primeng';
import { ActivatedRoute, Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  templateUrl: './customer-photos.component.html',
})
export class CustomerPhotosComponent implements OnInit {
  isBusy: boolean = true;
  page: IPageResult<ICustomer> = {
    items: [],
    total: 0,
  };
  selectedItem: ICustomer;

  filterSubject: Subject<ICustomerFilter>;
  filterVal: ICustomerFilter;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  onGridLazyLoad(event: LazyLoadEvent) {
    this.filterVal.first = event.first;
    this.filterVal.rows = event.rows;
    this.filterVal.sortField = event.sortField;
    this.filterVal.sortOrder = event.sortOrder;

    this.filterSubject.next(this.filterVal);
  }

  ngOnInit(): void {
    this._initDefaultFilter();
    this.filterSubject = new Subject<ICustomerFilter>();
    this.filterSubject.pipe(debounceTime(500)).subscribe((f) => this.load(f));
    this.filterSubject.next(this.filterVal);
  }

  load(filter: ICustomerFilter) {
    this.customerService.getPage(flatten(filter)).then((result) => {
      this.page.items = result.items;
      this.page.total = result.total;
      this.isBusy = false;
    });
  }

  clearFilter(dt: Table) {
    dt.sortField = '';
    dt.rows = 10;
    this._initDefaultFilter();
    this.filterSubject.next(this.filterVal);
  }

  search() {
    this.filterVal.first = 0;
    this.filterSubject.next(this.filterVal);
  }

  goToDetails() {
    this.router.navigate([this.selectedItem.id], { relativeTo: this.route });
  }

  private _initDefaultFilter() {
    this.filterVal = {
      first: 0,
      rows: 10,
      sortField: 'Name',
      sortOrder: 1,
      filters: {
        name: {},
        addressLine1: {},
        companyRegistrationNumber: {},
        country: {},
        organisationTypeName: { value: '2' },
        postcode: {},
        town: {},
      },
    };
  }
}
